import { cloneDeep } from "lodash";
import { GoodsIn } from "../../../models";

const DEFAULT_ATTRIBUTES = {
  quantity_received: null,
  quantity_sent: null,
  quantity_unlabel: null,
  type: null,
  variant: null,
  product: null,
  resource_type: null,
  resource: null,
  goods_in_id: null,
};

export class GoodsInItem {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      if (key === "transfer" || key === "pickup") {
        if (!!attrs[key]) {
          this.goodsIn = new GoodsIn(attrs[key]);
        }
      } else {
        this[key] = attrs[key];
      }
    });
  }
}
